module.exports = __webpack_public_path__ + "media/4.bf6bfe0e.mp4";